import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';

import { Icon } from '../icon';
import { SemanticButton } from '../semantic-button';

interface ZapProps {
  active: boolean;
  animate?: boolean;
  tooltip?: string;
  tooltipPosition?: 'top' | 'right';
  highlighted?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function Zap({
  active,
  animate = false,
  tooltip,
  tooltipPosition = 'top',
  highlighted,
  disabled,
  onClick,
}: ZapProps) {
  return (
    <Button
      data-rh={tooltip}
      data-rh-at={tooltipPosition}
      onClick={onClick}
      highlighted={highlighted}
      disabled={disabled}
    >
      {active && animate && (
        <AnimatedZapIcon
          icon={solid('bolt')}
          color="orange-60"
          fontSize="12px"
        />
      )}
      <ZapIcon
        icon={active ? solid('bolt') : regular('bolt')}
        color={active ? 'orange-100' : 'purple-60'}
        fontSize="12px"
      />
    </Button>
  );
}

const ping = keyframes`
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
`;

const Button = styled(SemanticButton)<{ highlighted?: boolean }>`
  position: relative;
  width: 24px;
  height: 24px;
  background-color: ${({ theme, highlighted }) =>
    highlighted ? theme.colors.purple[5] : 'transparent'};

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

const AnimatedZapIcon = styled(Icon)`
  animation: ${ping} 1250ms forwards;
  position: absolute;
  inset: 0;
  margin: auto;
`;

const ZapIcon = styled(Icon)`
  position: absolute;
  inset: 0;
  margin: auto;
`;
